<template>
  <div class="navbar">
    {{ title }}
  </div>
</template>

<script>
export default {
  name: 'navbar',
  data() {
    return {
      moduleName: '',
    }
  },
  computed: {
    title() {
      return this.$route.meta.module === 'external' ? '联系单位' : '权限管理'
    },
  },
}
</script>

<style lang="scss" scoped>
.navbar {
  z-index: 101;
  position: fixed;
  top: 0;
  height: 36px;
  min-width: 100%;
  line-height: 36px;
  color: #131d2d;
  font-size: 16px;
  background: #d3d9e2;
  border-bottom: 4px solid #fff;
  padding: 0 20px;
  font-weight: bold;
}
</style>
